import { singletonFactory } from '@warehouse/shared/util';
import { TransferSpec, TransferSpecResponse, AsperaParams, AsperaRepository } from '../core/aspera.repository';
import { inventoryFetchClientAdapter } from './nx-object-fetch-client';

export class AsperaRepositoryHttp implements AsperaRepository {
	#inventoryFetchClientAdapter = inventoryFetchClientAdapter;

	async asperaTransferSpec({ paths, destinationRoot, bucket }: AsperaParams): Promise<TransferSpec> {
		const { error, data } = await this.#inventoryFetchClientAdapter.client.POST('/aspera/transfer-spec', {
			body: {
				paths,
				destination_root: destinationRoot,
				bucket,
			},
		});

		if (error) throw new Error('Error fetching transfer spec');

		const transferSpec = (data as TransferSpecResponse)?.transfer_specs?.[0]?.transfer_spec;

		if (!transferSpec) {
			throw new Error('Missing transfer_spec in response');
		}

		return transferSpec;
	}
}

export const asperaSingleton = singletonFactory<AsperaRepository>({
	factory: () => new AsperaRepositoryHttp(),
});
